
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/en/ai/scheduling-rescheduling",
      function () {
        return require("private-next-pages/en/ai/scheduling-rescheduling/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/en/ai/scheduling-rescheduling"])
      });
    }
  